import { useContext } from "react";
import { searchContext } from "../context/DetailedSearchContext";

// eslint-disable-next-line import/prefer-default-export
export const useSearchModal = () => {
  const search = useContext(searchContext);

  return search;
};
